import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css"; // import CSS

const Header: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <header className="header">
      <h2>Webethics Admin Dashboard</h2>
      <button onClick={handleLogout} className="logout-btn">
        Logout
      </button>
    </header>
  );
};

export default Header;
